<template>
  <div
    v-element-loader="{ endpoint: 'cart/merge' }"
    class="merge-cart">
    <h3 class="merge-cart__header">
      {{ tStatic('mergeCartHeader') }}
    </h3>

    <p class="merge-cart__text">
      {{ tStatic('mergeCartText') }}
    </p>

    <div class="merge-cart__actions">
      <oie-base-button
        css-classes="button--ghost button--ghost-green"
        :text="tStatic('mergeCartYesMergeCarts')"
        @click="mergeCarts()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('mergeCartDontUseSavedCart')"
        @click="replaceCurrentCart()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('mergeCartUseSavedCart')"
        @click="useSavedCart()">
      </oie-base-button>
    </div>
  </div>
</template>

<script>
import cartMerge from '@/mixins/cart-merge.js'

export default {
  mixins: [cartMerge],
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.merge-cart__header {
  margin-top: 0;
}

.merge-cart__text {
  margin-top: 0;
  margin-bottom: measure(full);
}

.merge-cart__actions > button {
  width: 100%;
  margin-bottom: measure(quarter);

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
